<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'escortrec',
      breadcrumb: [
        { name: "财务管理", path: "/finance/estimatedProfit" },
        { name: "车队利润表", path: "/finance/estimatedProfit" },
        { name: "当月订单" },
      ],
      cols: [
        { prop: "order_num", label: "订单编号", width: 150 },
        { prop: "name", label: "货物名称" },
        { prop: "shname", label: "客户名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: "inton", label: "装货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "unton", label: "卸货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "addtime", label: "装货时间", width: 150 },
        { prop: "edittime", label: "卸货时间", width: 150 },
        { prop: "untons", label: "亏吨重量", align: 'right', className: 'pr30', width: 100 },
        { prop: "ceton", label: "公司承担亏吨", align: 'right', className: 'pr30', width: 130 },
        { prop: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', width: 100 },
        { prop: "untonmoney", label: "亏吨金额", align: 'right', className: 'pr30', width: 100 },
        { prop: "message", label: "信息费", align: 'right', className: 'pr30', width: 100 },
        { prop: "cprice", label: "公司单价", align: 'right', className: 'pr30', width: 100 },
        { prop: "freight", label: "公司运费", align: 'right', className: 'pr30', width: 100 },
        { prop: "dprice", label: "司机单价", align: 'right', className: 'pr30', width: 100 },
        { prop: "infreight", label: "司机运费", align: 'right', className: 'pr30', width: 100 },
        { prop: "total", label: "出车费用", align: 'right', className: 'pr30', width: 100 },
        { prop: "compen", label: "订单补差", align: 'right', className: 'pr30', width: 100 },
        { prop: "profit", label: "利润", align: 'right', className: 'pr30', width: 100 },
      ],
      baseParams: ['month', 'license'],
      getTotalProperty: [
        'inton',
        'unton',
        'untons',
        'ceton',
        'untonmoney',
        'message',
        'freight',
        'infreight',
        'total',
        'compen',
        'profit',
      ],
    };
  },
  methods: {},
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
